import { BulkMessageSenderInput, User } from "@/__generated__/graphql";
import { i18n } from "@/i18n";

export function formattedText(
  sender?: BulkMessageSenderInput,
  counselors?: Partial<User>[],
) {
  if (sender?.assignedCounselor) {
    return i18n.t(
      "bulkMessaging.composeMessage.inputs.sendFrom.assignedCounselor",
    );
  } else if (sender?.userId) {
    const counselor = counselors?.find((c) => c?.id === sender?.userId);
    if (counselor) {
      return `${counselor.firstName} ${counselor.lastName}`;
    } else {
      return i18n.t("bulkMessaging.review.formerOfficial");
    }
  } else {
    return "-";
  }
}
